import { useContext } from "react";

import { DeliveryAreaCreateContext } from "../contexts/DeliveryAreaCreateContext";

export const useDeliveryAreaCreateContext = () => {
  const context = useContext(DeliveryAreaCreateContext);
  if (context === undefined) {
    throw new Error(
      "useCreateShipmentContext must be within OrderCreateShippingContext",
    );
  }

  return context;
};
